import React, { MouseEvent } from 'react';

import ProductCardContainer from 'components/Common/Card/ProductCard/ProductCardContainer/ProductCardContainer';
import ProductCardImage from 'components/Common/Card/ProductCard/ProductCardImage/ProductCardImage';
import ProductCardDetails from 'components/Common/Card/ProductCard/ProductCardDetails/ProductCardDetails';
import ProductCardLabel from 'components/Common/Card/ProductCard/ProductCardLabel/ProductCardLabel';
import ProductCardPrice from 'components/Common/Card/ProductCard/ProductCardPrice/ProductCardPrice';
import ProductCardDiscount from 'components/Common/Card/ProductCard/ProductCardDiscount/ProductCardDiscount';
import { getUri } from 'services/generic';
import {
  getBrandName,
  getDiscountPercentage,
  getDiscountPrice,
  getFinalPrice,
  getLotQuantity,
  getName,
  getVisuelFace,
  hasUniqPrice,
} from 'services/product/attributes';
import { AcpProduct } from 'types/Acp';

import styles from './Product.module.scss';

type Props = {
  product: AcpProduct;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
};

export default function Product({
  product: { url, attributes },
  onClick,
}: Props): JSX.Element {
  const discountPercentage = getDiscountPercentage(attributes) || '';
  const finalPrice = getFinalPrice(attributes) || '';
  const productName = getName(attributes) || '';

  return (
    <ProductCardContainer linkTo={getUri(url)} onClick={onClick}>
      <ProductCardImage
        images={[
          {
            alt: productName,
            src: getVisuelFace(attributes) || '',
          },
        ]}
      >
        {parseFloat(discountPercentage) > 0 && (
          <ProductCardDiscount discountPercentage={discountPercentage} />
        )}
      </ProductCardImage>
      <ProductCardDetails>
        <div className={styles.labelPriceContainer}>
          <ProductCardLabel
            label={productName}
            brand={getBrandName(attributes)}
            className={styles.labelContainer}
          />
          {+finalPrice > 0 && (
            <ProductCardPrice
              price={finalPrice}
              hasUniqPrice={hasUniqPrice(attributes)}
              discountPrice={getDiscountPrice(attributes)}
              lotQuantity={getLotQuantity(attributes)}
              classes={{ priceFrom: styles.priceFrom }}
            />
          )}
        </div>
      </ProductCardDetails>
    </ProductCardContainer>
  );
}
